export const WORK_EXPERIENCE = [
  {
    title: "Arista Networks",
    img: "https://cdn.br-zhou.com/site-img/arista_logo.jfif",
    desc: "Software Engineer Intern",
    timeline: "Summer 2026 & Fall 2025",
    location: "Burnaby, BC",
  },
  {
    title: "Kardium Inc.",
    img: "https://cdn.br-zhou.com/site-img/kardium_logo.jfif",
    desc: "Software / Firmware Intern",
    timeline: "Summer 2025",
    location: "Burnaby, BC",
  },
  {
    title: "Intel Corporation",
    img: "https://cdn.br-zhou.com/site-img/intel_corporation_logo.jpg",
    desc: "System Simulation Intern",
    timeline: "Winter & Summer 2024",
    location: "Vancouver, BC",
  },
  {
    title: "UBC AeroDesign",
    img: "https://cdn.br-zhou.com/site-img/ubc_aerodesign_logo.jpg",
    desc: "Advanced Team - Avionics Member",
    timeline: "Sep. 2023 - Apr. 2025",
    location: "Vancouver, BC",
  },
  {
    title: "UBC Rocket",
    img: "https://cdn.br-zhou.com/site-img/ubc_rocket_logo.jpg",
    desc: "Whistler Blackcomb - Avionics Member",
    timeline: "Oct. 2022 - Apr. 2023",
    location: "Vancouver, BC",
  },
];

export const EDUCATION = [
  {
    title: "Bachelor of Science - Computer Science Honours",
    desc: "University of British Columbia",
    timeline: "Sep. 2022 - Present",
    points: ["4.03/4.33 GPA", "Dean's Honour List"],
    current: true,
  },
  {
    title: "High School Concurrent Studies - Computer Science",
    desc: "Simon Fraser University",
    timeline: "Sep. 2021 - Apr. 2022",
    points: ["CMPT 130 & CMPT 135"],
  },
];

export const CERTIFICATIONS = [
  {
    title: "CompTIA Security+",
    desc: "Credential ID: 6M116FQ5XJ1EKF2J",
    timeline: "Issued Jul. 2025",
    img: "https://cdn.br-zhou.com/site-img/comptia_securityplus_logo.png",
  },
  {
    title: "AWS Certified Database - Specialty",
    desc: "Credential ID: CKXYFN1K81B4QFST",
    timeline: "Issued Jun. 2023",
    img: "https://cdn.br-zhou.com/site-img/aws_database_logo.png",
  },
  {
    title: "Udemy: React - The Complete Guide",
    timeline: "Issued Aug. 2023",
    img: "https://cdn.br-zhou.com/site-img/udemy_logo.jpg",
  },
];
